import * as Yup from 'yup';
import { ValidationErrorMessages } from './errors';

export const locationValidator = Yup.object().shape({
  name: Yup.string().required(ValidationErrorMessages.REQUIRED),
  city: Yup.string().required(ValidationErrorMessages.REQUIRED),
  address: Yup.string().required(ValidationErrorMessages.REQUIRED),
  latitude: Yup.string().required(ValidationErrorMessages.REQUIRED),
  longitude: Yup.string().required(ValidationErrorMessages.REQUIRED),
});
